import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

export const wrapperSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
};
export const signInSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    '& a': {
        marginLeft: theme.spacing(4 / 8),
    },
};
export const welcomeBlockSx: SxProps<Theme> = {
    marginBottom: theme.spacing(60 / 8),
    [theme.breakpoints.down('lg')]: {
        marginBottom: theme.spacing(45 / 8),
    },
    [theme.breakpoints.down('md')]: {
        marginTop: theme.spacing(30 / 8),
        marginBottom: theme.spacing(30 / 8),
    },
};

export const langSelectWrapperSx: SxProps<Theme> = {
    [theme.breakpoints.down('md')]: {
        display: 'none',
    },
};

export const tabSx: SxProps<Theme> = {
    mt: 6,
    '& .MuiTabs-indicator': {
        display: 'none',
    },
};

export const tabsSx: (isActive: boolean, index: number) => SxProps<Theme> = (isActive, index) => ({
    borderWidth: theme.spacing(2 / 8),
    borderStyle: 'solid',
    borderColor: isActive ? theme.palette.primaryColor[100] : theme.palette.neutral[200],
    background: isActive ? theme.palette.primaryColor[50] : 'transparent',
    color: isActive ? theme.palette.primary.main : theme.palette.text.primary,
    maxHeight: theme.spacing(50 / 8),
    borderLeft: !isActive && index === 1 ? 'none' : undefined,
    borderRight: !isActive && index === 0 ? 'none' : undefined,
    textTransform: 'none',
    px: theme.spacing(20 / 6),
    borderTopRightRadius: index === 1 ? theme.spacing(2 / 4) : 0,
    borderBottomRightRadius: index === 1 ? theme.spacing(2 / 4) : 0,
    borderTopLeftRadius: index === 0 ? theme.spacing(2 / 4) : 0,
    borderBottomLeftRadius: index === 0 ? theme.spacing(2 / 4) : 0,
});
